import {NgModule} from "@angular/core";
import {CheckboxComponent} from "./checkbox.component";
import {FormsModule} from "@angular/forms";

@NgModule({
	declarations:[CheckboxComponent],
	exports:[CheckboxComponent],
	imports:[
		FormsModule
	]
})
export class CheckboxModule{

}
